/**
 * Payments
 */

export const payment = {
    namespaced: true,

    state: () => ({
        payments: [],
    }),

    mutations: {
        setPayments: (state, payload) => {
            state.payments = payload.items;
        },
    },
    
    actions: {
        getPayments: async ({ commit }) => {
            let { data } = await axios.get('/ajax/payment-methods');

            commit('setPayments', data);
        },
    },

    getters: {
    }
}